import { render, staticRenderFns } from "./LightAndTemperature.vue?vue&type=template&id=1176dc90&"
import script from "./LightAndTemperature.vue?vue&type=script&lang=js&"
export * from "./LightAndTemperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports